import { Validators } from '@angular/forms';
import { DistanceUnit } from '@app/enums/distance-unit';
import { Country } from '@models/country';
import { PersistentFormControl } from '@utility/persistent-forms';
import { maxLengthValidator, notWhitespaceValidator } from '@utility/utility.validators';
import { BaseExpenseFormGroup } from '../base-expense-edit.form';

export class MileageExpenseFormGroup extends BaseExpenseFormGroup<{
    fromLocation: PersistentFormControl<string>;
    toLocation: PersistentFormControl<string>;
    country: PersistentFormControl<Country>;
    isIncomplete: PersistentFormControl<boolean>;
    reimbursementRate: PersistentFormControl<string>;
    totalDistance: PersistentFormControl<string>;
    distanceUnit: PersistentFormControl<DistanceUnit>;
    comment: PersistentFormControl<string>;
    manualTotalCalculation: PersistentFormControl<boolean>;
}> {
    constructor() {
        super({
            fromLocation: new PersistentFormControl<string>('', [
                Validators.required,
                notWhitespaceValidator(),
                maxLengthValidator(500),
            ]),
            toLocation: new PersistentFormControl<string>('', [
                Validators.required,
                notWhitespaceValidator(),
                maxLengthValidator(500),
            ]),
            country: new PersistentFormControl<Country>(null, [Validators.required]),
            isIncomplete: new PersistentFormControl<boolean>(null),
            reimbursementRate: new PersistentFormControl<string>(null, [
                Validators.required,
                notWhitespaceValidator(),
                Validators.min(0),
                Validators.max(1e9),
            ]),
            totalDistance: new PersistentFormControl<string>(null, [
                Validators.required,
                notWhitespaceValidator(),
                Validators.min(0),
                Validators.max(1e6),
            ]),
            distanceUnit: new PersistentFormControl<DistanceUnit>(null, [Validators.required]),
            comment: new PersistentFormControl<string>('', [notWhitespaceValidator(), maxLengthValidator(500)]),
            manualTotalCalculation: new PersistentFormControl<boolean>(null),
        });

        this.controls.requestedAmountInLocalCurrency.disable({ persistent: true, emitEvent: true });
    }
}
